<template>
    <pt-dialog-v2
        v-model="props.visible"
        :title="t('experience.setting.update_design_title')"
        :z-index="props.zIndex"
        custom-class="editTemplateDialog"
        :append-to-body="true"
        :confirmButtonInfo="{
            disabled: !templateInfo?.name
        }"
        :confirmText="t('common.button_save')"
        @close="handleClose"
        @confirm="handleSave"
    >
        <div class="dialog-content">
            <pt-form :model="templateInfo" label-position="top">
                <pt-form-item prop="name" :label="t('experience.setting.design_name')">
                    <pt-input
                        v-model="templateInfo.name"
                        :class="$style.input"
                        size="large"
                        :maxLength="constantConfig.EXPERIENCE_TEMPLATE_NAME_MAX_LENGTH"
                    ></pt-input>
                </pt-form-item>
                <pt-form-item prop="description" :label="t('experience.setting.design_desc')">
                    <pt-input
                        v-model="templateInfo.description"
                        :class="$style.input"
                        size="large"
                    ></pt-input>
                </pt-form-item>
                <!-- <pt-form-item v-if="templateInfo.deviceType.length === 1">
                    <pt-checkbox v-model="templateInfo.sync">
                        {{
                            templateInfo.deviceType.includes('PC')
                                ? t('experience.setting.save_both_pc')
                                : t('experience.setting.save_both_mobile')
                        }}
                    </pt-checkbox>
                </pt-form-item> -->
            </pt-form>
        </div>
    </pt-dialog-v2>
</template>
<script lang="ts">
export default {
    name: 'ExperienceTemplateEditDialog'
};
</script>

<script lang="ts" setup>
import { ref, watch, onMounted, computed } from 'vue';
import { cloneDeep } from 'lodash-es';
import type { ExperienceTemplateV4 } from '@models/experience/useExperienceTemplatesV4';
import constantConfig from '@experience/config/constant.config';
import { useI18n } from 'vue-i18n';
interface Props {
    visible: boolean;
    template: ExperienceTemplateV4 | null;
}

const props = defineProps<Props>();
const emit = defineEmits(['save', 'close']);

const { t } = useI18n();
const templateInfo = ref<ExperienceTemplateV4>({
    name: '',
    description: '',
    sync: false,
    deviceType: ['PC']
});

watch(
    () => props.template,
    () => {
        templateInfo.value = cloneDeep(props.template);
    }
);

onMounted(() => {
    templateInfo.value = cloneDeep(props.template);
});

function handleClose() {
    emit('close');
}

function handleSave() {
    emit('save', templateInfo.value);
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
:global {
    .editTemplateDialog {
        .pt-form-item__label {
            line-height: 20px;
        }
        .pt-form-item {
            margin-bottom: 16px;
        }
        .pt-form-item:nth-last-child(1) {
            margin-bottom: 0;
        }
    }
}
</style>
